export const NEWSBOARD_POST_FORM_FIELD_NAME_TYPE = 'type'

export const NEWSBOARD_POST_FORM_FIELD_NAME_TITLE = 'title'

export const NEWSBOARD_POST_FORM_FIELD_NAME_MESSAGE = 'text'

export const NEWSBOARD_POST_FORM_FIELD_NAME_RECIPIENT = 'new_audience'

export const NEWSBOARD_POST_FORM_FIELD_NAME_START_DATE = 'date_from'

export const NEWSBOARD_POST_FORM_FIELD_NAME_END_DATE = 'date_to'

export const NEWSBOARD_POST_FORM_FIELD_NAME_COMMENTS = 'comments_forbidden'

export const NEWSBOARD_POST_FORM_FIELD_NAME_FILES = 'files'

export const NEWSBOARD_CREATION_FIELD_NAME_TEXT_TEMPLATE = 'template'

export const NEWSBOARD_POST_FORM_FIELD_DWELLER_BUILDINGS = 'dwellerBuildings'

export const NEWSBOARD_POST_FORM_FIELD_REQUESTS = 'requests'

export const NEWSBOARD_POST_FORM_FIELD_NAME_POST_AGE =
  'post_age_to_add_new_user'

export const NEWSBOARD_POST_FORM_RECIPIENTS_NAME_BUILDINGS = 'buildings'

export const NEWSBOARD_POST_FORM_TITLE_FIELD_MAX_LENGTH = 255

export const NEWSBOARD_POST_FORM_TICKER_TITLE_FIELD_MAX_LENGTH = 100

export const NEWSBOARD_POST_FORM_TICKER_MESSAGE_FIELD_MAX_LENGTH = 120

export const NEWSBOARD_POST_FORM_WYSIWYG_MIN_HEIGHT = 200

export const NEWSBOARD_POST_FORM_FIELD_NAME_INSERT_REPLACE =
  'insertReplaceTemplate'

export const ALL_BUILDINGS_OPTION = 'allBuildings'

export const ALL_BUILDINGS_COUNT = 'allBuildingsCount'

export const ALL_BUILDING_GROUPS_COUNT = 'allGroupsCount'

export const POST_AGE_MAX_VALUE = 3500

export const NEWSBOARD_POST_FORM_NOTIFICATION_AI_DRAFT_NOT_APPLIED =
  'aiDraftNotApplied'

export const NEWSBOARD_POST_FORM_SERVER_ERROR_TRANSLATION_KEY = {
  parameter_new_audience_must_not_be_empty: 'Newsboard.RecipientsEmptyErrorKey',
}
